import { render, staticRenderFns } from "./Wind.vue?vue&type=template&id=b9c32f06&scoped=true&"
import script from "./Wind.vue?vue&type=script&lang=js&"
export * from "./Wind.vue?vue&type=script&lang=js&"
import style0 from "./Wind.vue?vue&type=style&index=0&id=b9c32f06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c32f06",
  null
  
)

export default component.exports